/**
 * Company-default delivery settings for the create-chat flow.
 *
 * These mirror the Edit-chat delivery modal's defaults (every day available, no
 * cutoff) so a chat created without custom delivery settings behaves the same as
 * one edited later. Kept in the edit-modal's per-day `Record<Day, …>` shape so
 * the create flow can apply them through the same `updateSupplierDeliverySetting`
 * mutation.
 */

import type { CutoffTime, CutoffType, Day } from '@choco-admin/types';

export const DELIVERY_DAYS_ORDER: Day[] = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const DEFAULT_DELIVERY_DAYS: Record<Day, boolean> = {
  Monday: true,
  Tuesday: true,
  Wednesday: true,
  Thursday: true,
  Friday: true,
  Saturday: true,
  Sunday: true,
};

export const DEFAULT_CUTOFF_TIMES: Record<Day, CutoffTime> = {
  Monday: '23:59:59',
  Tuesday: '23:59:59',
  Wednesday: '23:59:59',
  Thursday: '23:59:59',
  Friday: '23:59:59',
  Saturday: '23:59:59',
  Sunday: '23:59:59',
};

export const DEFAULT_CUTOFF_DAYS: Record<Day, string> = {
  Monday: '1',
  Tuesday: '1',
  Wednesday: '1',
  Thursday: '1',
  Friday: '1',
  Saturday: '1',
  Sunday: '1',
};

export const DEFAULT_CUTOFF_TYPE: CutoffType = 'no_cutoff';
